<template>
  <svg :class="['svg-icon', size && `icon-${size}`]" aria-hidden="true" focusable="false" :style="{ pointerEvents: pointerEvents, color: 'inherit' }">
    <use :href="href" :xlink:href="href" fill="currentColor" stroke="currentColor" stroke-width="1" />
  </svg>
</template>

<script>
export const ICON = Object.freeze({
  ADD: 'add',
  ADIERESIS: 'adieresis',
  CANCEL: 'cancel',
  CONFIRM: 'confirm',
  CLOCK: 'clock',
  ERROR: 'error',
  INFORMATION: 'information',
  INFORMATION_2: 'information_2',
  LESS: 'less',
  RELOAD: 'reload',
  SECTION: 'section',
  LOCK: 'lock',
  SUCCESS: 'success',
  QUOTEDBL: 'quotedbl',
  DOLLAR: 'dollar',
  CONTEXT_MENU: 'context-menu',
  MOVE_TO_TRASH: 'move-to-trash',
  NAVIGATION_DOWN: 'navigation-down',
  NAVIGATION_UP: 'navigation-up',
  SEARCH: 'search',
  HOME: 'home',
  WARNING: 'warning',
  MY_PROFILE: 'my-profile',
});
const ICON_VALUES = Object.freeze(Object.values(ICON));
export const SIZE = Object.freeze({ SMALL: 'small', MIDDLE: 'middle', LARGE: 'large' });
export const POINTER_EVENTS = Object.freeze({ AUTO: 'auto', NONE: 'none' });
const PE_VALUES = Object.freeze(Object.values(POINTER_EVENTS));
const BASE_URL = (process.env.BASE_URL || '/').replace(/\/?$/, '/');

export default {
  name: 'VSvgIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: (nameValue) => ICON_VALUES.includes(nameValue),
    },
    variant: { type: String, default: 'outlined' },
    size: {
      type: String,
      default: SIZE.MIDDLE,
      validator: (nameValue) => nameValue === '' || [SIZE.SMALL, SIZE.MIDDLE, SIZE.LARGE].includes(nameValue),
    },
    pointerEvents: {
      type: String,
      default: POINTER_EVENTS.AUTO,
      validator: (nameValue) => PE_VALUES.includes(nameValue),
    },
  },
  computed: {
    href() {
      return `${BASE_URL}icons/teleicon-${this.variant}-sprite.svg#icon-${this.name}`;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/telekom-brand-and-design/scss/_svg-icons.scss';
</style>
